// src/components/AuthGuard.tsx
import { Navigate } from "react-router-dom";

export default function AuthGuard({
  children,
}: {
  children: JSX.Element;
}) {
  const token =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
